module.exports = __webpack_public_path__ + "static/media/page.bdc56a0f.jpg";